/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _toConsumableArray } from '../../_chunks/dep-fd3498b6.js';
import { _ as _defineProperty } from '../../_chunks/dep-46de7b2e.js';
import { i as isPlainObject_1 } from '../../_chunks/dep-f4a320cd.js';
import { g as get_1 } from '../../_chunks/dep-337b4140.js';
import OptionGroup from '../base/OptionGroup.js';
import Option from '../base/Option.js';
import '../../_chunks/dep-2acfafca.js';
import '../../_chunks/dep-c3f1141e.js';
import '../../_chunks/dep-4941ebe7.js';
import '../../_chunks/dep-e9b62d1f.js';
import '../../_chunks/dep-4b8f240e.js';
import '../../_chunks/dep-9acbc163.js';
import '../../_chunks/dep-7b52f080.js';
import '../../_chunks/dep-f10515e8.js';
import '../../_chunks/dep-88cd50bf.js';
import '../../_chunks/dep-dcb5aa2a.js';
import '../../_chunks/dep-ee4bf8c2.js';
import '../../_chunks/dep-934eda0c.js';
import '../../_chunks/dep-7dce2c26.js';
import '../../_chunks/dep-12510d64.js';
import '../../_chunks/dep-6b568d83.js';
import '../../_chunks/dep-304e657b.js';
import '../../_chunks/dep-77e34309.js';
import '../../_chunks/dep-6506fbc2.js';
import '../../_chunks/dep-ca64038e.js';
import '../../_chunks/dep-c1f93350.js';
import '../../_chunks/dep-33ffecad.js';
import 'react';
import 'classnames';
import '../../hooks/useConfig.js';
import '../../config-provider/ConfigContext.js';
import '../../_chunks/dep-d71ee5f3.js';
import '../../_chunks/dep-bb5d7b1e.js';
import '../../_chunks/dep-e285f2f8.js';
import '../../_chunks/dep-ec70b95c.js';
import '../../locale/zh_CN.js';
import '../../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../../_chunks/dep-cbcc9f89.js';
import '../../_common/js/global-config/default-config.js';
import '../defaultProps.js';
import '../../_chunks/dep-e43cf21c.js';
import '../../_chunks/dep-0e15088f.js';
import '../../_chunks/dep-6c5254c6.js';
import '../../hooks/useDomRefCallback.js';
import '../../_util/useRipple.js';
import '../../_util/useAnimation.js';
import '../../_util/setStyle.js';
import '../../_util/dom.js';
import 'raf';
import '../../_util/easing.js';

function setValueToOptionFormOptionDom(dom, valueToOption, keys) {
  var _valueToOption$value;
  var _dom$props = dom.props,
    value = _dom$props.value,
    label = _dom$props.label,
    children = _dom$props.children;
  valueToOption[value] = (_valueToOption$value = {}, _defineProperty(_valueToOption$value, (keys === null || keys === void 0 ? void 0 : keys.value) || "value", value), _defineProperty(_valueToOption$value, (keys === null || keys === void 0 ? void 0 : keys.label) || "label", label || children || value), _valueToOption$value);
}
var getValueToOption = function getValueToOption(children, options, keys) {
  var valueToOption = {};
  if (Array.isArray(options)) {
    options.forEach(function (option) {
      valueToOption[get_1(option, (keys === null || keys === void 0 ? void 0 : keys.value) || "value")] = option;
    });
    return valueToOption;
  }
  if (isPlainObject_1(children)) {
    if (children.type === Option) {
      setValueToOptionFormOptionDom(children, valueToOption, keys);
      return valueToOption;
    }
    if (children.type === OptionGroup) {
      var groupChildren = children.props.children;
      if (Array.isArray(groupChildren)) {
        groupChildren.forEach(function (item) {
          setValueToOptionFormOptionDom(item, valueToOption, keys);
        });
        return valueToOption;
      }
    }
  }
  if (Array.isArray(children)) {
    children.forEach(function (item) {
      if (item.type === Option) {
        setValueToOptionFormOptionDom(item, valueToOption, keys);
      }
      if (item.type === OptionGroup) {
        var _groupChildren = item.props.children;
        if (Array.isArray(_groupChildren)) {
          _groupChildren.forEach(function (groupItem) {
            setValueToOptionFormOptionDom(groupItem, valueToOption, keys);
          });
        }
      }
    });
  }
  return valueToOption;
};
var getLabel = function getLabel(children, value, options, keys) {
  var selectedLabel = "";
  if (Array.isArray(options)) {
    options.some(function (option) {
      if ([get_1(value, (keys === null || keys === void 0 ? void 0 : keys.value) || "value"), value].includes(option.value)) {
        selectedLabel = option.label;
        return true;
      }
      return false;
    });
    return selectedLabel;
  }
  if (isPlainObject_1(children)) {
    selectedLabel = children.props.label;
    if (children.type === OptionGroup) {
      var groupChildren = children.props.children;
      if (Array.isArray(groupChildren)) {
        groupChildren.some(function (item) {
          var selectedValue = isPlainObject_1(value) ? get_1(value, "value") : value;
          if (isPlainObject_1(item.props) && item.props.value === selectedValue) {
            selectedLabel = item.props.label || item.props.children;
            return true;
          }
          return false;
        });
      }
    }
  }
  if (Array.isArray(children)) {
    children.some(function (item) {
      if (item.type === OptionGroup) {
        var _groupChildren2 = item.props.children;
        if (Array.isArray(_groupChildren2)) {
          var isSelected = _groupChildren2.some(function (item2) {
            var selectedValue2 = isPlainObject_1(value) ? get_1(value, "value") : value;
            if (isPlainObject_1(item2.props) && item2.props.value === selectedValue2) {
              selectedLabel = item2.props.label || item2.props.children;
              return true;
            }
            return false;
          });
          return isSelected;
        }
      }
      var selectedValue = isPlainObject_1(value) ? get_1(value, "value") : value;
      if (isPlainObject_1(item.props) && item.props.value === selectedValue) {
        selectedLabel = item.props.label || item.props.children;
        return true;
      }
      return false;
    });
  }
  return selectedLabel;
};
var getMultipleTags = function getMultipleTags(values, keys) {
  var tags = values.map(function (item) {
    return {
      label: get_1(item, (keys === null || keys === void 0 ? void 0 : keys.label) || "label") || item.toString(),
      value: get_1(item, (keys === null || keys === void 0 ? void 0 : keys.value) || "value") || item
    };
  });
  return tags;
};
var getSelectValueArr = function getSelectValueArr(values, activeValue, selected, valueType, keys, objVal) {
  values = Array.isArray(values) ? values : [];
  if (Array.isArray(values)) {
    var currentValues = _toConsumableArray(values);
    var isValueObj = valueType === "object";
    if (selected) {
      currentValues = currentValues.filter(function (item) {
        if (isValueObj) {
          if (isPlainObject_1(activeValue)) {
            return get_1(item, (keys === null || keys === void 0 ? void 0 : keys.value) || "value") !== get_1(activeValue, (keys === null || keys === void 0 ? void 0 : keys.value) || "value");
          }
          return get_1(item, (keys === null || keys === void 0 ? void 0 : keys.value) || "value") !== activeValue;
        }
        return item !== activeValue;
      });
    } else {
      var item = isValueObj ? objVal : activeValue;
      currentValues.push(item);
    }
    return currentValues;
  }
};
var getSelectedOptions = function getSelectedOptions(value, multiple, valueType, keys, tmpPropOptions) {
  var isObjectType = valueType === "object";
  var currentSelectedOptions = [];
  if (multiple) {
    var _tmpPropOptions$filte;
    currentSelectedOptions = isObjectType ? value : tmpPropOptions === null || tmpPropOptions === void 0 ? void 0 : (_tmpPropOptions$filte = tmpPropOptions.filter) === null || _tmpPropOptions$filte === void 0 ? void 0 : _tmpPropOptions$filte.call(tmpPropOptions, function (v) {
      var _value$includes;
      return (_value$includes = value.includes) === null || _value$includes === void 0 ? void 0 : _value$includes.call(value, v[(keys === null || keys === void 0 ? void 0 : keys.value) || "value"]);
    });
  } else {
    var _tmpPropOptions$filte2;
    currentSelectedOptions = isObjectType ? [value] : (tmpPropOptions === null || tmpPropOptions === void 0 ? void 0 : (_tmpPropOptions$filte2 = tmpPropOptions.filter) === null || _tmpPropOptions$filte2 === void 0 ? void 0 : _tmpPropOptions$filte2.call(tmpPropOptions, function (v) {
      return value === v[(keys === null || keys === void 0 ? void 0 : keys.value) || "value"];
    })) || [];
  }
  return currentSelectedOptions;
};

export { getLabel, getMultipleTags, getSelectValueArr, getSelectedOptions, getValueToOption };
//# sourceMappingURL=helper.js.map
